import React from 'react';
import ProductCarouselShell from './ProductCarouselShell';

interface FeaturedCarouselProps {
  products: any[] | null;
  loading: boolean;
  onAddBag: (product: any, quantity: number) => void;
  onOpenProduct: (product: any) => void;
  onSeeAll: () => void;
  clientCode?: string;
}

const FeaturedCarousel: React.FC<FeaturedCarouselProps> = ({
  products,
  loading,
  onAddBag,
  onOpenProduct,
  onSeeAll,
  clientCode,
}) => {
  return (
    <ProductCarouselShell
      title="Imperdíveis"
      products={products}
      loading={loading}
      onSeeAll={onSeeAll}
      seeAllLabel="Ver todos"
      onAddBag={onAddBag}
      onOpenProduct={onOpenProduct}
      clientCode={clientCode}
    />
  );
};

export default React.memo(FeaturedCarousel);
